import { AlertsHistoryCard } from "./AlertsHistoryCard";
import { AlertThresholdsCard } from "./AlertThresholdsCard";
import { CodeHealthCard } from "./CodeHealthCard";
import { CompanyUsageCard } from "./CompanyUsageCard";
import { CronCard } from "./CronCard";
import { GeoUsageCard } from "./GeoUsageCard";
import { NotifyHealthCard } from "./NotifyHealthCard";
import { DelinquentCard } from "./DelinquentCard";
import { PaymentsHealthCard } from "./PaymentsHealthCard";
import { PerformanceCard } from "./PerformanceCard";
import { PlatformVoicePanel } from "./PlatformVoicePanel";
import { RevocationsCard } from "./RevocationsCard";
import { SessionsCard } from "./SessionsCard";
import { StorageCard } from "./StorageCard";
import { TrendCard } from "./TrendCard";

// بطاقات القسم المفتوح فقط — تُبعد شجرة الشروط عن SystemPanel.
export const SystemSection = ({ section, data, open, reload }) => {
  if (section === "code") return <CodeHealthCard data={data.code} onOpen={() => open("code")} />;

  if (section === "performance")
    return (
      <div className="grid gap-4">
        <TrendCard data={data.trends} onOpen={() => open("trends")} />
        <PerformanceCard data={data.performance} onOpen={() => open("performance")} />
      </div>
    );

  if (section === "storage") return <StorageCard data={data.storage} onOpen={() => open("storage")} />;

  if (section === "sessions")
    return (
      <div className="grid gap-4 xl:grid-cols-2">
        <SessionsCard data={data.sessions} onOpen={() => open("sessions")} />
        <RevocationsCard data={data.revocations} onOpen={() => open("revocations")} />
      </div>
    );

  if (section === "crons")
    return (
      <div className="grid gap-4 xl:grid-cols-2">
        <CronCard data={data.crons} onOpen={() => open("crons")} />
        <NotifyHealthCard data={data.notifyHealth} />
      </div>
    );

  if (section === "alerts")
    return (
      <div className="grid gap-4 xl:grid-cols-2">
        <AlertsHistoryCard data={data.alerts} onOpen={() => open("alerts")} />
        <AlertThresholdsCard data={data.thresholds} onSaved={reload} />
      </div>
    );

  if (section === "usage") return <CompanyUsageCard data={data.companies} onOpen={() => open("companies")} />;

  if (section === "voice") return <PlatformVoicePanel />;

  if (section === "payments")
    return (
      <div className="grid gap-6">
        <PaymentsHealthCard />
        <DelinquentCard />
      </div>
    );

  return <GeoUsageCard geo={data.geo} integrations={data.integrations} onOpen={() => open("geo")} />;
};
